// extracted by mini-css-extract-plugin
export default {"single":"UserSnapShots_single__lqOlV","mainContainer":"UserSnapShots_mainContainer__4JfKg","centerContent":"UserSnapShots_centerContent__osnmd"};